import F84Game from "../Game";
import LoadingContainer from "../ui/LoadingContainer";
import ActionQueue from "../utils/ActionQueue";
import BaseURL from "../utils/BaseURL";
import LoadBatches from "../utils/LoadBatches";
import LoaderScene from "./LoaderScene";

export default class PreloaderScene extends LoaderScene {
	private _onResize: () => any;

	private _loadingContainer: LoadingContainer;
	private _destinationScene: string;
	sceneState: any;

	init(data: { destinationScene: string; sceneState?: any }): void {
		this._destinationScene = "SplashScene";
		if (data.destinationScene) this._destinationScene = data.destinationScene;
		if (data.sceneState) this.sceneState = data.sceneState;
		else this.sceneState = {};
		super.init();
	}

	public preload(): void {
		super.preload();

		this.soundManager.stop("rampSFX");
		this.soundManager.stop("ambienceSFX");

		this._loadingContainer = new LoadingContainer(this);
		this.add.existing(this._loadingContainer);

		this.load.setBaseURL(BaseURL.getBaseURL());
		F84Game.Instance.loadBatches.loadBatchesForScene(this, this._destinationScene);

		this.loadImages("./locale/" + F84Game.Instance.locale + "/", {});

		this.loadUpdate();
	}

	loadUpdate(): void {
		const percentComplete = this.load.totalComplete / this.load.totalToLoad;
		this._loadingContainer.setLoadPercent(percentComplete);
	}

	resize(): void {
		super.resize();
		if (this._onResize != null) this._onResize();
	}

	create(): void {
		const queue = new ActionQueue();

		//load level assets
		const destinationBatches = F84Game.Instance.loadBatches.sceneBatches.get(this._destinationScene) as string;
		if (destinationBatches == "GameplayBatches") {
			const level = this.sceneState.level.name;
			//console.log("level: " + level);
			queue.add((complete) => {
				F84Game.Instance.loadBatches.loadBatch(this, LoadBatches.loadLevelAssets(this, level));
				this.load.once(Phaser.Loader.Events.COMPLETE, complete);
				this.load.start();
			});
		}

		queue.add(() => {
			super.create();
			this.next();
		});
		queue.start();

		// ScreenTransition.to(this, this._destinationScene);
	}

	next(): void {
		this.scene.start(this._destinationScene, this.sceneState);
		this.scene.stop(this.scene.key);
	}
}
